export default __webpack_public_path__ + "static/media/asraLogo2.efd1352d.png";